export default "__VITE_ASSET__BZh1FC7J__"